export default __webpack_public_path__ + "static/media/link.549cced2.svg";